export enum EUsageTime {
  Morning = 'morning',
  Midday = 'midday',
  Afternoon = 'afternoon',
  Night = 'night'
}
